const RoleType = Object.freeze({
    ADMIN: 0,
    OWNER: 1,
    PRACTITIONER: 2,
    FULFILMENT: 3,
})

export default RoleType